module.exports = __webpack_public_path__ + "img/4.fdbb7e68.jpg";